export default __webpack_public_path__ + "static/media/Brochure_kn.0b44344e.pdf";